export const CustomRegisterForm = "CustomRegisterForm";
export const ParentNameActivity = "Activity";
export const ParentNameCard = "Card";

export enum CustomerStatus { Active = 0, Temp = 1 }

export enum LevelProvider { Pandora = 0, WPR = 1 }

export const PublicActivityStatusFilters = {
  All: "all",
  Ongoing: "ongoing",
  Upcoming: "upcoming",
  Finished: "finished",
} as const;

export const PublicActivityTypeFilters = {
  Registration: "registration",
  Inscription: "inscription",
  Activity: "activity",
  Generic: "generic",
  Teams: "teams",
} as const;
